export { default as ThreeDStockMaterialsFiltersAppliedFilters } from './ThreeDStockMaterialsFiltersAppliedFilters';
